<template>
  <section v-if="renderComponent" v-cloak id="claims-select-damagetype">
    <router-view />
  </section>
</template>

<script>
import { isUndefined } from 'lodash';

export default {
  name: 'QuestionTree',
  props: {
    tree: {
      type: Object,
      default() {
        return null;
      }
    },
    myProducts: {
      type: Array,
      default() {
        return null;
      }
    },
    settings: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    renderComponent() {
      return this.tree !== null && this.myProducts !== null && this.settings !== null;
    }
  },
  mounted() {
    if (!this.renderComponent) {
      return;
    }

    this.$store.dispatch('claimQuestionTree/initiate', {
      tree: this.tree,
      myProducts: this.myProducts,
      settings: this.settings
    });

    if (isUndefined(this.$route.params.level1)) {
      return this.$router.push('/produkter');
    }
  }
};
</script>
